//src\components\EmailLeadershipModal.js
import React, { useState, useEffect } from 'react';
import {
  Modal,
  View,
  ScrollView,
  TouchableOpacity,
  KeyboardAvoidingView,
  Platform,
  Alert,
} from 'react-native';
import {
  Text,
  TextInput,
  Button,
  IconButton,
  ActivityIndicator,
  Chip,
  Divider,
  Portal,
} from 'react-native-paper';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { AVAQualisTheme } from '../theme/theme';

// Componente de Preview Estilizado (funciona em todas as plataformas)
const EmailPreviewComponent = ({ form, customMessage }) => {
  const avaliador1 = form.metadata?.avaliador1Nome || 'Avaliador 1';
  const avaliador2 = form.metadata?.avaliador2Nome || 'Avaliador 2';
  const dataAvaliacao = form.metadata?.dataAvaliacao || 'Data não definida';
  const horarioAvaliacao = form.metadata?.horarioAvaliacao || 'Horário não definido';
  const localAvaliacao = form.metadata?.localAvaliacao || 'Local não definido';
  const contatoAvaliacao = form.metadata?.contatoAvaliacao || 'Contato não definido';
  const unidades = form.metadata?.unidadesOrganizacionais || [];
  const requisitos = form.requirements || [];
  const essentialCount = requisitos.filter(r => r.isEssential).length;

  return (
    <ScrollView style={{ flex: 1, backgroundColor: '#f5f7fa' }}>
      <View
        style={{
          maxWidth: 650,
          margin: 20,
          alignSelf: 'center',
          width: '100%',
          backgroundColor: '#fff',
          borderRadius: 12,
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.05,
          shadowRadius: 10,
          elevation: 3,
        }}
      >
        {/* Header */}
        <View
          style={{
            padding: 30,
            backgroundColor: '#A4C639',
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
          }}
        >
          <Text
            style={{
              fontSize: 28,
              fontWeight: 'bold',
              color: '#fff',
              marginBottom: 10,
            }}
          >
            📋 AVAQualis - <Text style={{ color: '#E8F5A2' }}>Notificação de Avaliação</Text>
          </Text>
          <Text style={{ fontSize: 14, color: '#E8F5A2' }}>
            Lembrete importante sobre avaliação programada
          </Text>
        </View>

        {/* Content */}
        <View style={{ padding: 30 }}>
          {/* Mensagem personalizada */}
          {customMessage && (
            <View
              style={{
                backgroundColor: '#F0F7FF',
                borderRadius: 8,
                padding: 20,
                borderLeftWidth: 4,
                borderLeftColor: '#4299E1',
                marginBottom: 25,
              }}
            >
              <Text
                style={{
                  fontSize: 16,
                  color: '#2B6CB0',
                  fontWeight: 'bold',
                  marginBottom: 10,
                }}
              >
                Mensagem da Coordenação:
              </Text>
              <Text
                style={{
                  fontSize: 15,
                  color: '#4A5568',
                  lineHeight: 22,
                }}
              >
                {customMessage}
              </Text>
            </View>
          )}

          <Text
            style={{
              fontSize: 22,
              fontWeight: 'bold',
              color: '#2C3E50',
              marginBottom: 20,
            }}
          >
            📅 Avaliação Agendada
          </Text>

          {/* Informações da avaliação */}
          <View
            style={{
              backgroundColor: '#F8F9FA',
              borderRadius: 8,
              padding: 20,
              marginBottom: 25,
            }}
          >
            <View style={{ marginBottom: 8 }}>
              <Text style={{ fontWeight: 'bold', color: '#718096' }}>Data:</Text>
              <Text style={{ fontSize: 16, color: '#2C3E50' }}>{dataAvaliacao}</Text>
            </View>
            <View style={{ marginBottom: 8 }}>
              <Text style={{ fontWeight: 'bold', color: '#718096' }}>Horário:</Text>
              <Text style={{ fontSize: 16, color: '#2C3E50' }}>{horarioAvaliacao}</Text>
            </View>
            <View style={{ marginBottom: 8 }}>
              <Text style={{ fontWeight: 'bold', color: '#718096' }}>Local:</Text>
              <Text style={{ fontSize: 16, color: '#2C3E50' }}>{localAvaliacao}</Text>
            </View>
            <View>
              <Text style={{ fontWeight: 'bold', color: '#718096' }}>Contato:</Text>
              <Text style={{ fontSize: 16, color: '#2C3E50' }}>{contatoAvaliacao}</Text>
            </View>
          </View>

          {/* Avaliadores */}
          <View
            style={{
              backgroundColor: '#E8F5E9',
              borderRadius: 8,
              padding: 20,
              marginBottom: 25,
              borderLeftWidth: 4,
              borderLeftColor: '#A4C639',
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontWeight: 'bold',
                color: '#2E7D32',
                marginBottom: 15,
              }}
            >
              👥 Avaliadores Designados
            </Text>
            <Text style={{ fontSize: 16, color: '#2C3E50' }}>
              <Text style={{ fontWeight: 'bold' }}>1º Avaliador:</Text> {avaliador1}
            </Text>
            <Text style={{ fontSize: 16, color: '#2C3E50' }}>
              <Text style={{ fontWeight: 'bold' }}>2º Avaliador:</Text> {avaliador2}
            </Text>
          </View>

          {/* Unidades */}
          {unidades.length > 0 && (
            <View
              style={{
                backgroundColor: '#F8F9FA',
                borderRadius: 8,
                padding: 20,
                marginBottom: 25,
              }}
            >
              <Text
                style={{
                  fontSize: 18,
                  fontWeight: 'bold',
                  color: '#2C3E50',
                  marginBottom: 15,
                }}
              >
                🏢 Unidades a Serem Avaliadas ({unidades.length})
              </Text>
              {unidades.map((unidade, index) => (
                <View
                  key={index}
                  style={{
                    marginBottom: 10,
                    padding: 10,
                    backgroundColor: '#fff',
                    borderRadius: 6,
                    borderWidth: 1,
                    borderColor: '#E2E8F0',
                  }}
                >
                  <Text style={{ fontWeight: 'bold', color: '#A4C639' }}>
                    {index + 1}. {unidade.codigo} - {unidade.nome}
                  </Text>
                  <Text style={{ fontSize: 14, color: '#718096', marginTop: 4 }}>
                    📞 {unidade.telefone} • 📧 {unidade.email}
                  </Text>
                </View>
              ))}
            </View>
          )}

          {/* Resumo dos requisitos */}
          <View
            style={{
              backgroundColor: '#FFF8E1',
              borderRadius: 8,
              padding: 20,
              marginBottom: 25,
              borderLeftWidth: 4,
              borderLeftColor: '#FFC107',
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontWeight: 'bold',
                color: '#F57C00',
                marginBottom: 15,
              }}
            >
              📋 Resumo do Roteiro
            </Text>
            <Text style={{ fontSize: 16, marginBottom: 5 }}>
              <Text style={{ fontWeight: 'bold' }}>Total de Requisitos:</Text> {requisitos.length}
            </Text>
            {essentialCount > 0 && (
              <Text style={{ fontSize: 16, color: '#FF6B00' }}>
                <Text style={{ fontWeight: 'bold' }}>
                  Destes, {essentialCount} são Requisitos Essenciais (RE)
                </Text>
              </Text>
            )}
          </View>

          {/* Lista completa de requisitos */}
          <View
            style={{
              backgroundColor: '#F8F9FA',
              borderRadius: 8,
              padding: 20,
              marginBottom: 25,
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontWeight: 'bold',
                color: '#2C3E50',
                marginBottom: 15,
              }}
            >
              📝 Lista Completa de Requisitos
            </Text>
            {requisitos.map((req, index) => {
              if (req.isEssential) {
                // Requisito Essencial com destaque
                return (
                  <View
                    key={index}
                    style={{
                      marginBottom: 20,
                      padding: 15,
                      backgroundColor: '#FFF3E0',
                      borderRadius: 8,
                      borderLeftWidth: 4,
                      borderLeftColor: '#FF6B00',
                    }}
                  >
                    <View
                      style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 8,
                        marginBottom: 12,
                        flexWrap: 'wrap',
                      }}
                    >
                      <View
                        style={{
                          backgroundColor: '#A4C639',
                          paddingHorizontal: 12,
                          paddingVertical: 4,
                          borderRadius: 16,
                        }}
                      >
                        <Text
                          style={{
                            color: '#fff',
                            fontSize: 12,
                            fontWeight: '600',
                          }}
                        >
                          📋 {req.codigo}
                        </Text>
                      </View>
                      <View
                        style={{
                          backgroundColor: '#FFE0B2',
                          paddingHorizontal: 8,
                          paddingVertical: 4,
                          borderRadius: 12,
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <Text
                          style={{
                            color: '#FF6B00',
                            fontSize: 12,
                            fontWeight: '600',
                          }}
                        >
                          ⚠️ RE
                        </Text>
                      </View>
                    </View>

                    <Text
                      style={{
                        fontSize: 14,
                        color: '#2C3E50',
                        lineHeight: 20,
                        marginBottom: 12,
                        fontWeight: 'bold',
                      }}
                    >
                      Requisito: <Text style={{ fontWeight: 'normal' }}>{req.question}</Text>
                    </Text>

                    {req.premissa && (
                      <View
                        style={{
                          marginBottom: 10,
                          padding: 10,
                          backgroundColor: '#FFF8E1',
                          borderRadius: 6,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 13,
                            color: '#666',
                            lineHeight: 18,
                          }}
                        >
                          <Text style={{ fontWeight: 'bold', color: '#FF6B00' }}>Premissa:</Text>{' '}
                          {req.premissa}
                        </Text>
                      </View>
                    )}

                    {req.fontes && (
                      <View
                        style={{
                          marginBottom: 10,
                          padding: 10,
                          backgroundColor: '#FFF8E1',
                          borderRadius: 6,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 13,
                            color: '#666',
                            lineHeight: 18,
                          }}
                        >
                          <Text style={{ fontWeight: 'bold', color: '#FF6B00' }}>
                            Fontes de Informação:
                          </Text>{' '}
                          {req.fontes}
                        </Text>
                      </View>
                    )}

                    {req.segmento && (
                      <View
                        style={{
                          padding: 10,
                          backgroundColor: '#FFF8E1',
                          borderRadius: 6,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 13,
                            color: '#666',
                            lineHeight: 18,
                            fontStyle: 'italic',
                          }}
                        >
                          <Text style={{ fontWeight: 'bold', color: '#FF6B00' }}>Segmento:</Text>{' '}
                          {req.segmento}
                        </Text>
                      </View>
                    )}

                    {req.grupoRequisito && (
                      <View
                        style={{
                          marginTop: 10,
                          padding: 10,
                          backgroundColor: '#E8F5E9',
                          borderRadius: 6,
                        }}
                      >
                        <Text style={{ fontSize: 13, color: '#2E7D32', lineHeight: 18 }}>
                          <Text style={{ fontWeight: 'bold', color: '#1B5E20' }}>
                            Grupo do Requisito:
                          </Text>{' '}
                          {req.grupoRequisito}
                        </Text>
                      </View>
                    )}

                    {req.sugestaoRoteiro && (
                      <View
                        style={{
                          marginTop: 10,
                          padding: 10,
                          backgroundColor: '#F0F7FF',
                          borderRadius: 6,
                        }}
                      >
                        <Text style={{ fontSize: 13, color: '#2B6CB0', lineHeight: 18 }}>
                          <Text style={{ fontWeight: 'bold', color: '#1A237E' }}>
                            Sugestão de Roteiro:
                          </Text>{' '}
                          {req.sugestaoRoteiro}
                        </Text>
                      </View>
                    )}
                  </View>
                );
              } else {
                // Requisito normal
                return (
                  <View
                    key={index}
                    style={{
                      marginBottom: 15,
                      padding: 12,
                      backgroundColor: '#fff',
                      borderRadius: 6,
                      borderWidth: 1,
                      borderColor: '#E2E8F0',
                    }}
                  >
                    <View style={{ marginBottom: 10 }}>
                      <View
                        style={{
                          backgroundColor: '#F5F5F5',
                          paddingHorizontal: 10,
                          paddingVertical: 4,
                          borderRadius: 12,
                          alignSelf: 'flex-start',
                        }}
                      >
                        <Text
                          style={{
                            color: '#666',
                            fontSize: 12,
                            fontWeight: '500',
                          }}
                        >
                          {req.codigo}
                        </Text>
                      </View>
                    </View>

                    <Text
                      style={{
                        fontSize: 14,
                        color: '#4A5568',
                        lineHeight: 20,
                        marginBottom: 10,
                        fontWeight: 'bold',
                      }}
                    >
                      Requisito: <Text style={{ fontWeight: 'normal' }}>{req.question}</Text>
                    </Text>

                    {req.premissa && (
                      <View
                        style={{
                          marginBottom: 8,
                          padding: 8,
                          backgroundColor: '#F8F9FA',
                          borderRadius: 4,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 13,
                            color: '#666',
                            lineHeight: 18,
                          }}
                        >
                          <Text style={{ fontWeight: 'bold' }}>Premissa:</Text> {req.premissa}
                        </Text>
                      </View>
                    )}

                    {req.fontes && (
                      <View
                        style={{
                          marginBottom: 8,
                          padding: 8,
                          backgroundColor: '#F8F9FA',
                          borderRadius: 4,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 13,
                            color: '#666',
                            lineHeight: 18,
                          }}
                        >
                          <Text style={{ fontWeight: 'bold' }}>Fontes de Informação:</Text>{' '}
                          {req.fontes}
                        </Text>
                      </View>
                    )}

                    {req.segmento && (
                      <View
                        style={{
                          padding: 8,
                          backgroundColor: '#F8F9FA',
                          borderRadius: 4,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 13,
                            color: '#666',
                            lineHeight: 18,
                            fontStyle: 'italic',
                          }}
                        >
                          <Text style={{ fontWeight: 'bold' }}>Segmento:</Text> {req.segmento}
                        </Text>
                      </View>
                    )}
                    {req.grupoRequisito && (
                      <View
                        style={{
                          marginTop: 8,
                          padding: 8,
                          backgroundColor: '#F0F4C3',
                          borderRadius: 4,
                        }}
                      >
                        <Text style={{ fontSize: 13, color: '#556B2F', lineHeight: 18 }}>
                          <Text style={{ fontWeight: 'bold' }}>Grupo do Requisito:</Text>{' '}
                          {req.grupoRequisito}
                        </Text>
                      </View>
                    )}

                    {req.sugestaoRoteiro && (
                      <View
                        style={{
                          marginTop: 8,
                          padding: 8,
                          backgroundColor: '#E3F2FD',
                          borderRadius: 4,
                        }}
                      >
                        <Text style={{ fontSize: 13, color: '#1E88E5', lineHeight: 18 }}>
                          <Text style={{ fontWeight: 'bold' }}>Sugestão de Roteiro:</Text>{' '}
                          {req.sugestaoRoteiro}
                        </Text>
                      </View>
                    )}
                  </View>
                );
              }
            })}
          </View>

          {/* Lembretes */}
          <View
            style={{
              backgroundColor: '#F0F7FF',
              borderRadius: 8,
              padding: 15,
            }}
          >
            <Text
              style={{
                fontSize: 14,
                color: '#2B6CB0',
                fontWeight: 'bold',
                marginBottom: 10,
              }}
            >
              ℹ️ Lembretes Importantes:
            </Text>
            <Text style={{ fontSize: 14, color: '#4A5568', marginBottom: 4 }}>
              • Confirme sua disponibilidade com antecedência
            </Text>
            <Text style={{ fontSize: 14, color: '#4A5568', marginBottom: 4 }}>
              • Revise os requisitos antes da avaliação
            </Text>

            <Text style={{ fontSize: 14, color: '#4A5568' }}>
              • Em caso de impedimento, comunique imediatamente a coordenação do AVAQualis do
              HC-UFU/EBSERH
            </Text>
          </View>
        </View>

        {/* Footer */}
        <View
          style={{
            padding: 20,
            backgroundColor: '#F8F9FA',
            borderBottomLeftRadius: 12,
            borderBottomRightRadius: 12,
            alignItems: 'center',
          }}
        >
          <Text style={{ fontSize: 12, color: '#718096', textAlign: 'center' }}>
            Este é um email automático enviado pelo sistema AVAQualis.com{'\n'}
            HC-UFU/EBSERH - UGITS + UGQ{'\n'}© {new Date().getFullYear()} Todos os direitos
            reservados
          </Text>
        </View>
      </View>
    </ScrollView>
  );
};

const EmailLeadershipModal = ({ visible, onDismiss, form, currentUser, onSendEmail }) => {
  const [customMessage, setCustomMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sendingMessage, setSendingMessage] = useState('');
  const [previewMode, setPreviewMode] = useState(false);

  useEffect(() => {
    if (visible) {
      // Reset ao abrir
      setCustomMessage('');
      setPreviewMode(false);
      setSending(false);
      setSendingMessage('');
    }
  }, [visible]);

  if (!form || !visible) return null;

  const handleSend = async () => {
    setSending(true);
    setSendingMessage('Preparando email...');

    try {
      // Simular progresso de envio
      setTimeout(() => setSendingMessage('Conectando ao servidor...'), 500);
      setTimeout(() => setSendingMessage('Enviando para lideranças...'), 1500);
      setTimeout(() => setSendingMessage('Enviando cópias aos avaliadores...'), 2500);

      await onSendEmail(form.id, customMessage, {
        id: currentUser.id,
        nome: currentUser.nome,
        login: currentUser.email,
      });

      setSendingMessage('Email enviado com sucesso! ✅');

      // Aguardar 1.5 segundos mostrando sucesso antes de fechar
      setTimeout(() => {
        onDismiss();
        Alert.alert(
          '✅ Email Enviado com Sucesso!',
          `Notificação enviada para:\n\n` +
            `📧 Lideranças: ${form.metadata?.emailsLiderancas?.join(', ')}\n` +
            `📋 Avaliadores: Em cópia`,
          [{ text: 'OK' }]
        );
      }, 1500);
    } catch (error) {
      setSending(false);
      setSendingMessage('');
      Alert.alert(
        '❌ Erro ao Enviar',
        'Não foi possível enviar o email. ' + (error.message || 'Tente novamente.'),
        [{ text: 'OK' }]
      );
    }
  };

  const getLastEmailInfo = () => {
    if (!form.emailsSent || form.emailsSent.length === 0) return null;

    const lastEmail = form.emailsSent[form.emailsSent.length - 1];
    const date = new Date(lastEmail.sentAt);

    return {
      date: date.toLocaleDateString('pt-BR'),
      time: date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
      sentBy: lastEmail.sentBy?.nome || 'Sistema',
      status: lastEmail.status,
      recipients: lastEmail.recipients,
    };
  };

  const lastEmailInfo = getLastEmailInfo();
  const essentialCount = form.requirements?.filter(r => r.isEssential).length || 0;

  return (
    <Portal>
      <Modal visible={visible} transparent={true} animationType="slide" onRequestClose={onDismiss}>
        <KeyboardAvoidingView
          style={{ flex: 1, backgroundColor: 'rgba(0,0,0,0.5)' }}
          behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        >
          {/* Loading Overlay */}
          {sending && (
            <View
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.7)',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
              }}
            >
              <View
                style={{
                  backgroundColor: '#FFFFFF',
                  padding: 30,
                  borderRadius: 16,
                  alignItems: 'center',
                  shadowColor: '#000',
                  shadowOffset: { width: 0, height: 4 },
                  shadowOpacity: 0.3,
                  shadowRadius: 8,
                  elevation: 10,
                }}
              >
                <ActivityIndicator size="large" color={AVAQualisTheme.colors.primary} />
                <Text
                  style={{
                    marginTop: 16,
                    fontSize: 16,
                    fontWeight: 'bold',
                    color: AVAQualisTheme.colors.primary,
                  }}
                >
                  Enviando Email
                </Text>
                <Text
                  style={{
                    marginTop: 8,
                    fontSize: 14,
                    color: '#666',
                    textAlign: 'center',
                  }}
                >
                  {sendingMessage}
                </Text>
              </View>
            </View>
          )}

          <TouchableOpacity style={{ flex: 1 }} activeOpacity={1} onPress={onDismiss} />

          <View
            style={{
              backgroundColor: '#FFFFFF',
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              maxHeight: '90%',
              shadowColor: '#000',
              shadowOffset: { width: 0, height: -2 },
              shadowOpacity: 0.25,
              shadowRadius: 4,
              elevation: 5,
            }}
          >
            {/* Header */}
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                padding: 16,
                borderBottomWidth: 1,
                borderBottomColor: '#E0E0E0',
              }}
            >
              <MaterialCommunityIcons
                name="email-send"
                size={24}
                color={AVAQualisTheme.colors.primary}
              />
              <Text
                style={{
                  flex: 1,
                  fontSize: 18,
                  fontWeight: 'bold',
                  marginLeft: 12,
                  color: '#333',
                }}
              >
                Enviar Notificação às Lideranças
              </Text>
              <IconButton icon="close" size={24} onPress={onDismiss} />
            </View>

            {!previewMode ? (
              <ScrollView style={{ padding: 16 }}>
                {/* Status do último envio */}
                {lastEmailInfo && (
                  <View
                    style={{
                      backgroundColor: lastEmailInfo.status === 'success' ? '#E8F5E9' : '#FFEBEE',
                      borderRadius: 8,
                      padding: 12,
                      marginBottom: 16,
                      borderLeftWidth: 4,
                      borderLeftColor: lastEmailInfo.status === 'success' ? '#4CAF50' : '#F44336',
                    }}
                  >
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                      <MaterialCommunityIcons
                        name={lastEmailInfo.status === 'success' ? 'check-circle' : 'alert-circle'}
                        size={20}
                        color={lastEmailInfo.status === 'success' ? '#4CAF50' : '#F44336'}
                      />
                      <Text
                        style={{
                          marginLeft: 8,
                          fontWeight: 'bold',
                          color: lastEmailInfo.status === 'success' ? '#2E7D32' : '#D32F2F',
                        }}
                      >
                        Email enviado com sucesso!
                      </Text>
                    </View>

                    <View style={{ marginTop: 8, marginLeft: 28 }}>
                      <Text style={{ fontSize: 12, color: '#666' }}>
                        📅 {lastEmailInfo.date} às {lastEmailInfo.time}
                      </Text>
                      <Text style={{ fontSize: 12, color: '#666' }}>
                        👤 Por: {lastEmailInfo.sentBy}
                      </Text>
                      {lastEmailInfo.recipients && (
                        <>
                          <Text style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                            📧 Para: {lastEmailInfo.recipients.to?.join(', ')}
                          </Text>
                          <Text style={{ fontSize: 12, color: '#666' }}>
                            📋 CC: {lastEmailInfo.recipients.cc?.join(', ')}
                          </Text>
                        </>
                      )}
                    </View>
                  </View>
                )}

                {/* Informações do formulário */}
                <View
                  style={{
                    backgroundColor: '#F5F5F5',
                    borderRadius: 8,
                    padding: 16,
                    marginBottom: 16,
                  }}
                >
                  <Text style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 8 }}>
                    📋 {form.title}
                  </Text>

                  <View style={{ marginBottom: 8 }}>
                    <Text style={{ color: '#666' }}>
                      📅 Data: {form.metadata?.dataAvaliacao} às {form.metadata?.horarioAvaliacao}
                    </Text>
                    <Text style={{ color: '#666' }}>📍 Local: {form.metadata?.localAvaliacao}</Text>
                    <Text style={{ color: '#666' }}>
                      📞 Contato: {form.metadata?.contatoAvaliacao}
                    </Text>
                  </View>

                  <Divider style={{ marginVertical: 8 }} />

                  <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8 }}>
                    <Chip mode="flat" compact>
                      📝 {form.totalQuestions} requisitos
                    </Chip>
                    {essentialCount > 0 && (
                      <Chip mode="flat" compact style={{ backgroundColor: '#FFEBEE' }}>
                        ⚠️ {essentialCount} RE
                      </Chip>
                    )}
                    <Chip mode="flat" compact>
                      📧 {form.metadata?.emailsLiderancas?.length || 0} lideranças
                    </Chip>
                  </View>
                </View>

                {/* Destinatários */}
                <View style={{ marginBottom: 16 }}>
                  <Text style={{ fontWeight: 'bold', marginBottom: 8 }}>Destinatários:</Text>

                  <Text style={{ color: '#666', marginBottom: 4 }}>
                    <Text style={{ fontWeight: 'bold' }}>Para:</Text>{' '}
                    {form.metadata?.emailsLiderancas?.join(', ') || 'Nenhum email cadastrado'}
                  </Text>

                  <Text style={{ color: '#666' }}>
                    <Text style={{ fontWeight: 'bold' }}>CC:</Text> Avaliadores do roteiro
                  </Text>
                </View>

                {/* Mensagem personalizada */}
                <View style={{ marginBottom: 16 }}>
                  <Text style={{ fontWeight: 'bold', marginBottom: 8 }}>
                    Mensagem Personalizada (opcional):
                  </Text>

                  <TextInput
                    mode="outlined"
                    multiline
                    numberOfLines={5}
                    value={customMessage}
                    onChangeText={setCustomMessage}
                    placeholder="Digite aqui uma mensagem adicional que será incluída no email..."
                    style={{ backgroundColor: '#FFF' }}
                  />

                  <Text
                    style={{
                      fontSize: 12,
                      color: '#666',
                      marginTop: 4,
                      fontStyle: 'italic',
                    }}
                  >
                    Esta mensagem aparecerá no início do email, após o cabeçalho.
                  </Text>
                </View>

                {/* Botão de preview */}
                <Button
                  mode="outlined"
                  onPress={() => setPreviewMode(true)}
                  icon="eye"
                  style={{ marginBottom: 16 }}
                >
                  Visualizar como ficará o email
                </Button>
              </ScrollView>
            ) : (
              /* Preview Mode */
              <View style={{ flex: 1 }}>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    padding: 12,
                    backgroundColor: '#F5F5F5',
                    borderBottomWidth: 1,
                    borderBottomColor: '#E0E0E0',
                  }}
                >
                  <IconButton icon="arrow-left" size={24} onPress={() => setPreviewMode(false)} />
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 16,
                      fontWeight: 'bold',
                      color: '#333',
                    }}
                  >
                    Prévia do Email
                  </Text>
                </View>

                {/* Preview usando componente nativo */}
                <EmailPreviewComponent form={form} customMessage={customMessage} />
              </View>
            )}

            {/* Footer com botões (apenas quando não está em preview) */}
            {!previewMode && (
              <View
                style={{
                  flexDirection: 'row',
                  padding: 16,
                  borderTopWidth: 1,
                  borderTopColor: '#E0E0E0',
                  gap: 12,
                }}
              >
                <Button mode="outlined" onPress={onDismiss} style={{ flex: 1 }} disabled={sending}>
                  Cancelar
                </Button>

                <Button
                  mode="contained"
                  onPress={handleSend}
                  style={{ flex: 1 }}
                  loading={sending}
                  disabled={sending || !form.metadata?.emailsLiderancas?.length}
                  icon="email-send"
                >
                  {lastEmailInfo ? 'Reenviar Email' : 'Enviar Email'}
                </Button>
              </View>
            )}
          </View>
        </KeyboardAvoidingView>
      </Modal>
    </Portal>
  );
};

export default EmailLeadershipModal;
